// **Which application this phone is about to download.**
//
// Two very different readers arrive at the same origin. One is a member of
// staff on a desk who wants the operations console. The other is a customer in
// a queue who scanned a paper cup sleeve, will read one page, and will never
// come back.
//
// Until this file split, they both downloaded the same thing: `main.jsx`
// imported `App.jsx`, which imports every screen in the console, so the
// customer's phone pulled **4.4 MB of JavaScript and the whole Tailwind
// stylesheet** before a National Day prize could appear. On café wifi that is
// the difference between a gift and a white screen — and no amount of design
// on the page behind it can be seen through a ten-second wait.
//
// So nothing is imported at the top of this file. The path decides, and Vite
// splits the two apps into chunks that never touch each other. The console
// pays one extra round trip on first load; the customer stops paying for a
// console they will never open.
const isRevealPage = typeof window !== "undefined"
  && window.location.pathname.startsWith("/v/");

// **And an app that will not load says so (21 Oct 2026).** These imports had no
// catch: a chunk gone with an old deploy left the page white, and the console's
// own stale-chunk reload lives inside the chunk that failed. index.html's boot
// guard reloads once, then shows a Reload button (src/lib/boot-guard.test.js).
if (window.location.pathname === "/me" || window.location.pathname.startsWith("/me/")) {
  import("./me-main.jsx").catch(() => window.__7gBootFailed?.());
} else if (isRevealPage) {
  import("./reveal-main.jsx").catch(() => window.__7gBootFailed?.());
} else {
  import("./console-main.jsx").catch(() => window.__7gBootFailed?.());
}
